export default __webpack_public_path__ + "static/media/antd.70107c48.png";